import { render, staticRenderFns } from "./SebaranOPM.vue?vue&type=template&id=4e6cf9b0&scoped=true&"
import script from "./SebaranOPM.vue?vue&type=script&lang=js&"
export * from "./SebaranOPM.vue?vue&type=script&lang=js&"
import style0 from "./Overview.scss?vue&type=style&index=0&id=4e6cf9b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6cf9b0",
  null
  
)

export default component.exports